import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './NurseDashboard.css';

function NurseDashboard() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('http://localhost:5000/api/sessions', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setSessions(data.sessions);
      }
    } catch (error) {
      console.error('Error fetching sessions:', error);
    } finally {
      setLoading(false);
    }
  };

  const viewSession = (sessionId) => {
    navigate(`/session/${sessionId}`);
  };

  if (loading) {
    return <div className="nurse-dashboard"><div className="loading">Loading...</div></div>;
  }

  return (
    <div className="nurse-dashboard">
      <div className="dashboard-header">
        <h1>Nurse Dashboard</h1>
        <p>View assigned clinical sessions and medical information</p>
      </div>

      <div className="dashboard-stats">
        <div className="stat-card">
          <h3>{sessions.length}</h3>
          <p>Assigned Sessions</p>
        </div>
        <div className="stat-card">
          <h3>{sessions.filter(s => s.status === 'pending').length}</h3>
          <p>Pending Review</p>
        </div>
        <div className="stat-card">
          <h3>{sessions.filter(s => s.status === 'completed').length}</h3>
          <p>Completed</p>
        </div>
      </div>

      <div className="sessions-section">
        <h2>Assigned Clinical Sessions</h2>
        <div className="sessions-table">
          <table>
            <thead>
              <tr>
                <th>Session ID</th>
                <th>Patient</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sessions.map(session => (
                <tr key={session.id}>
                  <td>{session.session_id}</td>
                  <td>Patient #{session.patient_id}</td>
                  <td>{new Date(session.created_at).toLocaleDateString()}</td>
                  <td>
                    <span className={`status-badge ${session.status}`}>
                      {session.status}
                    </span>
                  </td>
                  <td>
                    <button 
                      onClick={() => viewSession(session.session_id)}
                      className="btn-view"
                    >
                      View Medical Info
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {sessions.length === 0 && (
            <div className="no-sessions">
              <p>No sessions assigned to you yet.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NurseDashboard;
